import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ILabelInformation } from'@ar2/common'
/**
 * 単行テキスト表示フィールド
 *【ラベル内容:label:string】
 *【内容1:firstValue:string】
 *【内容2:secondValue:string】
 *【表示条件:visible:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-single-line-display-field',
  templateUrl: './single-line-display-field.html',
  styles: [`
    
  `]
})
export class SingleLineDisplayField extends BaseWidget {
  /**
   * ラベル内容
   */
  @Input() label:string

  /**
   * 内容1
   */
  @Input() firstValue:string

  /**
   * 内容2
   */
  @Input() secondValue:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * 内容
   */
  get labelInfo():ILabelInformation {
    const value = {
      'label':this.label?this.label:this.title,
      'firstValue':this.firstValue,
      'secondValue':this.secondValue
    }
    return value;
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/single-line-display-field/single-line-display-field.component.ts